
import {
  Usuario
} from '../index';


export class LoginSAP {
  "TransacaoSAP";
  "SAP_User";
  "SAP_Password";
  "SAP_Ambiente";
  "DataCadastro";
  "UsuarioCadastro";
  "DataAlteracao";
  "UsuarioAlteracao";
  "id";
  UsuarioCadastroRel;
  UsuarioAlteracaoRel;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LoginSAP`.
   */
  static getModelName() {
    return "LoginSAP";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LoginSAP for dynamic purposes.
  **/
  static factory(data) {
    return new LoginSAP(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'LoginSAP',
      plural: 'LoginSAPs',
      path: 'LoginSAPs',
      properties: {
        "TransacaoSAP": {
          name: 'TransacaoSAP',
          type: 'string'
        },
        "SAP_User": {
          name: 'SAP_User',
          type: 'string'
        },
        "SAP_Password": {
          name: 'SAP_Password',
          type: 'string'
        },
        "SAP_Ambiente": {
          name: 'SAP_Ambiente',
          type: 'string'
        },
        "DataCadastro": {
          name: 'DataCadastro',
          type: 'Date'
        },
        "UsuarioCadastro": {
          name: 'UsuarioCadastro',
          type: 'number'
        },
        "DataAlteracao": {
          name: 'DataAlteracao',
          type: 'Date'
        },
        "UsuarioAlteracao": {
          name: 'UsuarioAlteracao',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        UsuarioCadastroRel: {
          name: 'UsuarioCadastroRel',
          type: 'Usuario',
          model: 'Usuario'
        },
        UsuarioAlteracaoRel: {
          name: 'UsuarioAlteracaoRel',
          type: 'Usuario',
          model: 'Usuario'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/LoginSAP.js